var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelphi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2349,
    height: 872,
    viewBox: "0 0 2349 872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2348.29 435.731C2345.74 695.396 1822.64 871.434 1174.12 871.434C525.624 871.434 0 708.039 0 419.257C0 179.869 525.624 0 1174.12 0C1822.64 0 2352.09 178.583 2348.29 435.731Z",
    fill: "#CF4037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 322.987H1076.62V504.115H1256.49V534.518H1012.01V322.987ZM1588.34 322.987H1651.63V411.649H1846.72V322.987H1910.04V538.321H1846.72V442.052H1651.63V538.321H1588.34V322.987V322.987ZM1953.11 537.063H2021.5V322.987H1953.11V537.063ZM430.641 322.987C714.36 322.987 723.226 537.063 431.9 537.063H286.236V322.987H430.641V322.987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M436.989 353.389C624.439 349.585 624.439 509.177 435.731 506.66H350.845V353.389H436.989V353.389Z",
    fill: "#CF4037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.01 322.987C1606.07 322.987 1606.07 452.204 1427.46 452.204H1345.15V537.09H1280.54V323.015H1430.01V322.987V322.987Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.59 353.39C1514.84 353.39 1516.12 423.061 1418.59 423.061H1346.38V353.39H1418.59Z",
    fill: "#CF4037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M976.543 359.739C889.14 336.944 752.343 339.461 733.352 410.418H905.614V437.017H733.352C758.691 543.412 977.829 499.108 977.829 499.108L982.892 530.769C982.892 530.769 671.315 577.645 661.19 424.374C675.119 298.961 914.507 309.114 982.892 328.105L976.543 359.739V359.739ZM2054.45 504.116V507.947H2065.86V537.063H2070.89V507.947H2082.3V504.116H2054.45ZM2088.62 504.116V537.063H2093.71V509.178L2103.84 537.063H2107.64L2117.77 509.178V537.063H2122.83V504.116H2115.22L2105.1 531.973L2096.23 504.116H2088.62ZM1174.12 55.7422V160.878C1174.12 160.878 -88.6618 131.734 93.7251 524.393C93.7251 524.393 -207.754 120.323 1174.12 55.7422V55.7422Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.21 819.496V714.387C1179.21 714.387 2442.01 743.503 2259.63 350.872C2259.63 350.872 2559.82 754.914 1179.21 819.496V819.496Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelphi);
export default __webpack_public_path__ + "static/media/delphi.0b6842e17e427f20cdccf5f270ff5074.svg";
export { ForwardRef as ReactComponent };